import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Alert } from '@cimpress/react-components';
import { Component } from 'react';
export class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = {
            hasError: false,
            error: null,
            errorInfo: null
        };
    }
    componentDidCatch(error, errorInfo) {
        this.setState({
            hasError: true,
            error,
            errorInfo
        });
    }
    render() {
        var _a;
        const { t } = this.props;
        if (this.state.hasError) {
            const errorMessage = _jsxs(_Fragment, { children: [(_a = this.state.error) === null || _a === void 0 ? void 0 : _a.message, _jsx("br", {}), _jsx("br", {}), t('pleaseContact'), " ", _jsx("a", Object.assign({ href: "mailto:trdelniksquad@cimpress.com" }, { children: "Trdelniksquad@cimpress.com" }))] });
            return (_jsxs("div", { children: [_jsx(Alert, { title: t('somethingWentWrong'), message: errorMessage, dismissible: false }), _jsxs("details", Object.assign({ style: { whiteSpace: 'pre-wrap' } }, { children: [_jsx("br", {}), this.state.errorInfo && this.state.errorInfo.componentStack] }))] }));
        }
        return this.props.children;
    }
}
